// Generated by genversion.
export const version = '5.44.2';
